import React, { useEffect, useState } from 'react';
import { Drawer, Form, Button, Select, InputNumber, Input } from 'antd';
import errorMessage from 'global_config/error_messages';
import { RegexInput } from 'shared_components/pattern_input';
import fetchSection from 'services/shared/section';
import {
	addQualityControlLotNo,
	fetchAnalyzerNameItems,
	fetchLevelItems,
} from 'services/settings/qualityControl';
import HttpCodeMessage from 'shared_components/message_http_status';

const LotNoForm = ({ visible, onClose, record, autoSearch }) => {
	const [form] = Form.useForm();
	const { Option } = Select;

	const [sections, setSection] = useState(null);
	const [levelNameData, setLevelNameData] = useState(null);
	const [AnalyzerNameData, setAnalyzerNameData] = useState(null);
	const [levelCode, setLevelCode] = useState(null);

	const onSubmit = async value => {
		console.log(value);

		if (record) {
			const payload = {
				mlotno: value ? value.lotno : null,
				manalyzername: value ? value.analyzername : null,
				msectionname: value ? value.sectionname : null,
				mlevelname: value ? value.levelname : null,
				mlevel: value ? value.level : null,

				manalyteid: record ? record.analyteid : null,
				mexamcode: value ? value.examcode : null,
				mexamname: value ? value.examname : null,

				manexamcode: value ? value.examcode : null,
				mlslvalue: value ? value.lslvalue : null,
				mevvalue: value ? value.evvalue : null,
				muslvalue: value ? value.uslvalue : null,
			};

			const response = await addQualityControlLotNo(payload);
			console.log(response);

			// @ts-ignore
			if (response.status === 200) {
				const httpMessageConfig = {
					message: 'Update successful!',
					// @ts-ignore
					status: response.status,
					duration: 3,
				};
				HttpCodeMessage(httpMessageConfig);
				form.resetFields();

				// @ts-ignore
				autoSearch(response.data.records[0].lotno);
			}

			console.log('update lotno');
			console.log(payload);
		} else {
			const payload = {
				mlotno: value ? value.lotno : null,
				manalyzername: value ? value.analyzername : null,
				msectionname: value ? value.sectionname : null,
				mlevelname: value ? value.levelname : null,
				mlevel: value ? value.level : null,

				mexamcode: value ? value.examcode : null,
				mexamname: value ? value.examname : null,

				manexamcode: value ? value.examcode : null,
				mlslvalue: value ? value.lslvalue : null,
				mevvalue: value ? value.evvalue : null,
				muslvalue: value ? value.uslvalue : null,
			};

			console.log('add lotno');
			console.log(payload);
			const response = await addQualityControlLotNo(payload);
			console.log(response);

			// @ts-ignore
			if (response.status === 200) {
				const httpMessageConfig = {
					message: 'Successfully created!',
					// @ts-ignore
					status: response.status,
					duration: 3,
				};
				HttpCodeMessage(httpMessageConfig);
				form.resetFields();

				// @ts-ignore
				autoSearch(response.data.records[0].lotno);
			}
		}
	};

	const fetchData = async () => {
		try {
			const sectionsData = await fetchSection();
			const levelNameData = await fetchLevelItems();
			const analyzerNameData = await fetchAnalyzerNameItems();
			// Process the data or update the state
			setSection(sectionsData);
			setLevelNameData(levelNameData.records);
			setAnalyzerNameData(analyzerNameData.records);
		} catch (error) {
			console.error('Error fetching data:', error);
			// Handle the error gracefully
		}
	};

	const levelCodeValue = value => {
		console.log(value);
		const findData = levelNameData.find(item => item.value === value);
		form.setFieldsValue({ level: findData.code });
	};

	useEffect(() => {
		const errors = form.getFieldsError();
		const hasErrors = Object.keys(errors).some(field => errors[field]);

		if (hasErrors) {
			form.resetFields(); // Reset the form if there are errors
		}

		fetchData();

		form.setFieldsValue({
			lotno: record ? record.lotno : null,
			analyzername: record ? record.analyzername : null,
			sectionname: record ? record.sectionname : null,
			levelname: record ? record.levelname : null,
			level: record ? record.level : 0,

			analyteid: record ? record.analyteid : null,
			examcode: record ? record.examcode : null,
			examname: record ? record.examname : null,

			anexamcode: record ? record.anexamcode : null, // same result of examcode
			lslvalue: record ? record.lslvalue : null,
			evvalue: record ? record.evvalue : null,
			uslvalue: record ? record.uslvalue : null,
		});
	}, [form, record]);

	const fieldRules = {
		required: [
			{ required: true, message: errorMessage.required },
			// { max: 20, message: errorMessage.maxLength(20) },
		],
	};

	return (
		<Drawer
			title={`${record ? 'UPDATE' : 'ADD'} LOT NO.`}
			width="50%"
			placement="right"
			closable
			onClose={() => onClose(false)}
			visible={visible}
		>
			<Form
				form={form}
				onFinish={onSubmit}
				className="quality-control-lotNo-container"
				layout="vertical"
			>
				<div className="form">
					<Form.Item name="lotno" label="LOT N0." rules={fieldRules.required}>
						<RegexInput
							regex={/[A-Za-z0-9 -]/}
							maxLength={200}
							minLength={4}
							width={200}
							disabled={record ? true : false}
						/>
					</Form.Item>
					<Form.Item name="analyzername" label="MACHINE" rules={fieldRules.required}>
						<Select disabled={record ? true : false}>
							{AnalyzerNameData
								? AnalyzerNameData.map(item => <Option value={item.value}>{item.value}</Option>)
								: null}
						</Select>
					</Form.Item>
					<Form.Item name="sectionname" label="SECTION" rules={fieldRules.required}>
						<Select disabled={record ? true : false}>
							{sections
								? sections.map(item => <Option value={item.sectionName}>{item.sectionName}</Option>)
								: null}
						</Select>
					</Form.Item>
					<Form.Item name="levelname" label="LEVEL NAME" rules={fieldRules.required}>
						<Select disabled={record ? true : false} onChange={value => levelCodeValue(value)}>
							{levelNameData
								? levelNameData.map(item => <Option value={item.value}>{item.value}</Option>)
								: null}
						</Select>
					</Form.Item>
					<Form.Item name="level" label="LEVEL">
						<Input type="number" disabled={true} style={{ width: '100%' }} />
					</Form.Item>
					<Form.Item name="examcode" label="EXAM CODE" rules={fieldRules.required}>
						<Input
							type="text"
							maxLength={50}
							disabled={record ? true : false}
							style={{ width: '100%' }}
						/>
					</Form.Item>
					<Form.Item name="examname" label="EXAM NAME" rules={fieldRules.required}>
						<Input
							type="text"
							maxLength={50}
							disabled={record ? true : false}
							style={{ width: '100%' }}
						/>
					</Form.Item>
					<Form.Item name="lslvalue" label="LSL VALUE" rules={fieldRules.required}>
						<Input type="number" />
					</Form.Item>
					<Form.Item name="evvalue" label="EV VALUE" rules={fieldRules.required}>
						<Input type="number" />
					</Form.Item>
					<Form.Item name="uslvalue" label="USL VALUE" rules={fieldRules.required}>
						<Input type="number" />
					</Form.Item>
				</div>

				<section className="drawerFooter">
					<div>
						<Button shape="round" style={{ margin: 10, width: 120 }} onClick={() => onClose(false)}>
							CANCEL
						</Button>
						<Button
							shape="round"
							type="primary"
							htmlType="submit"
							style={{ margin: 10, width: 120 }}
						>
							{record ? 'UPDATE' : 'ADD'}
						</Button>
					</div>
				</section>
			</Form>
		</Drawer>
	);
};

export default LotNoForm;
